// The bundled translation resources. Two languages × five namespaces, imported
// statically (a few KB) so there's no async loader and no Suspense boundary —
// `main.tsx` can keep its synchronous render. `pricing` is deliberately NOT a
// namespace here: the pricing-display overlay (./pricingOverlay) reads
// de/pricing.json directly and resolves English from @fd/pricing, so it stays
// asymmetric on purpose (EN passes through to the marketing catalog).
import en_common from "./locales/en/common.json";
import en_builder from "./locales/en/builder.json";
import en_signing from "./locales/en/signing.json";
import en_portal from "./locales/en/portal.json";
import en_legal from "./locales/en/legal.json";
import de_common from "./locales/de/common.json";
import de_builder from "./locales/de/builder.json";
import de_signing from "./locales/de/signing.json";
import de_portal from "./locales/de/portal.json";
import de_legal from "./locales/de/legal.json";

import en_support from "./locales/en/support.json";
import de_support from "./locales/de/support.json";

export const ns = ["common", "builder", "signing", "portal", "legal", "support"] as const;
export const defaultNS = "common" as const;

export const resources = {
  en: {
    common: en_common,
    builder: en_builder,
    signing: en_signing,
    portal: en_portal,
    legal: en_legal,
    support: en_support,
  },
  de: {
    common: de_common,
    builder: de_builder,
    signing: de_signing,
    portal: de_portal,
    legal: de_legal,
    support: de_support,
  },
} as const;
